<template>

  <div class="dlnkmessages_message_components">

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="close_message()"
    ></dlnkalert>

    <dlnkmessages-new-message
        :subject="subject"
        :reply_recipient="reply_recipient"
        :group_id="''"
    ></dlnkmessages-new-message>

    <div id="content" class="bg-white">
      <div id="dlnmessages-message-page" class="p-0">

        <!-- Title Section -->
        <div class="position-relative bg-light">
          <div class="container space-1 space-top-lg-1 space-bottom-sm-2 space-bottom-lg-2">
            <!-- Title -->
            <div class="w-md-80 w-lg-65 text-center mx-md-auto mb-5 mb-md-4">
              <h1 id="dlnkcalendar-title" class="mb-0 text-secondary">Messagerie</h1>
            </div>
            <!-- End Title -->

            <div class="text-center mb-lg-4">
              <button type="button"  class="btn btn-secondary transition-3d-hover"
                 data-tooltip="tooltip" title="Répondre"
                 @click="reply()">
                <i class="fa fa-reply" aria-hidden="true"></i> &nbsp;
                Répondre
              </button>

              <button type="button" id="new_message" class="btn btn-primary pull-right"
                      data-tooltip="tooltip" title="Nouveau message"
                      data-toggle="modal" data-target="#new_message_modal">
                        <span>
                            <i class="fa fa-plus" aria-hidden="true"></i> &nbsp;
                            Nouveau message
                        </span>
              </button>
            </div>
          </div>

          <!-- SVG Bottom Shape -->
          <figure class="position-absolute bottom-0 right-0 left-0">
            <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                 viewBox="0 0 1920 100.1">
              <path fill="#fff" d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"/>
            </svg>
          </figure>
          <!-- End SVG Bottom Shape -->
        </div>
        <!-- End Title Section -->

        <!-- Message Section -->
        <div class="container">
          <div class="row justify-content-lg-between">

            <dlnkmessages-sidebar
                :api_url="api_url"
                :customer_id="customer_id"
                @change_box="change_box($event)">
            </dlnkmessages-sidebar>

            <div class="col-lg-8">
              <!-- Message -->
              <article class="row mb-7">
                <div class="col">
                  <div class="card-body d-flex flex-column h-100 px-0">
                    <span class="d-block mb-2">
                      <span class="text-primary font-weight-bold float-right">Le {{current_message.created_at}}</span>
                    </span>

                    <h3 class="mb-4">
                      <span class="text-inherit">
                        {{current_message.subject}}
                      </span>
                    </h3>

                    <div class="media align-items-center mt-auto">
                      <a class="avatar avatar-circle mr-3">

                        <img v-if="current_message.sender.has_photo"
                             :src="'/module/datools/getcustomerphoto?ref=' + current_message.sender.customer_reference"
                             class="avatar-img" :alt="'Photo de ' + current_message.sender.name"
                             style="width:100%; border-radius: 6px;"/>

                        <img v-else src="/themes/template/img/picto_compte/photo_manquante.jpg"
                             style="width:100%; border-radius: 6px;" class="avatar-img" alt="Photo manquante" />

                      </a>

                      <div class="media-body">
                        <span class="text-dark">
                          <span class="d-block text-inherit font-weight-bold" href="javascript:void(0);">
                            <strong>De : </strong>{{current_message.sender.name}}
                          </span>
                        </span>

                        <button type="button" name="delete_message"
                                data-tooltip="tooltip" title="Supprimer le message"
                                @click="delete_message()"
                                class="btn btn-sm btn-danger float-right">
                          <i class="fa fa-trash" aria-hidden="true"></i>
                        </button>

                        <button type="button" name="reply_message"
                                data-tooltip="tooltip" title="Répondre"
                                @click="reply()"
                                class="btn btn-sm btn-info float-right mr-1">
                          <i class="fa fa-reply" aria-hidden="true"></i>
                        </button>

                      </div>
                    </div>

                    <div class="mt-4 border-top pt-2" style="font-size: 1.05rem;line-height: 1.3rem;color: black;" v-html="current_message.message"></div>

                  </div>
                </div>
              </article>
              <!-- End Message -->

              <!-- Sticky Block End Point -->
              <div id="stickyBlockEndPoint"></div>
            </div>

          </div>

        </div>
        <!-- End Message Section -->
      </div>
    </div>
  </div>

</template>

<script>

export default {
  props: ['api_url', 'customer_id', 'message_user_id', 'message_id'],
  data: function () {
    return {
      message_type: "",
      message: "",
      current_message: {
        sender: {
          name: ""
        }
      },
      subject: String,
      reply_recipient: Object
    }
  },

  mounted() {
    this.get_data()
    this.subject = ""
    this.reply_recipient = {}
  },

  methods: {

    change_box: function (box_id) {
      window.location.replace("/module/dlnkmessages/messages?box_id=" + box_id);
      // this.box_id = box_id
      // this.get_data()
    },

    close_message: function () {
      this.message = null;
    },

    delete_message: async function () {

      const _this = this;
      let api_url = _this.api_url + "messages/" + _this.message_id + ".json";

      const secure_key = await get_token();
      api_url += '?secure_key=' + secure_key;
      api_url += '&customer_id=' + this.customer_id;

      axios.delete(api_url)
          .then(function (response) {
            _this.current_message = response.data
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
                // always executed
              }
          );

    },

    reply: function () {

      const _this = this

      _this.subject = "RE: " + _this.current_message.subject
      _this.reply_recipient = _this.current_message.sender

      $('#new_message_modal').modal('toggle')
    },

    get_data: async function () {

      const _this = this;
      let api_url = _this.api_url + "/messages/" + _this.message_user_id + ".json"

      const secure_key = await get_token();
      api_url += '?secure_key=' + secure_key;
      api_url += '&customer_id=' + this.customer_id;

      axios.get(api_url)
          .then(function (response) {
            _this.current_message = response.data
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
                // always executed
              }
          );
    },

  },
}
</script>
